
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Mixed Use" fileName="mixture-filter.md" />
        <p>According to different business scenarios, it can be used arbitrarily</p>
<demo-block>
        <div><p>You can set the default selected item by <code>selected=true</code></p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table :max-height=&quot;300&quot; :fixed-header=&quot;true&quot; :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
    // name fiter list
    const NAME_FILTER_LIST = [
        { value: 0, label: &quot;John&quot;, selected: true },
        { value: 1, label: &quot;Dickerson&quot;, selected: true },
        { value: 2, label: &quot;Larsen&quot;, selected: false },
        { value: 3, label: &quot;Geneva&quot;, selected: true },
        { value: 4, label: &quot;Jami&quot;, selected: false },
    ];

    // date fiter list
    const Date_FILTER_LIST = [
        { value: 0, label: &quot;1900-05-20&quot;, selected: false },
        { value: 1, label: &quot;1910-06-20&quot;, selected: false },
        { value: 2, label: &quot;2000-07-20&quot;, selected: false },
        { value: 3, label: &quot;2010-08-20&quot;, selected: false },
        { value: 4, label: &quot;2020-09-20&quot;, selected: false },
    ];

    export default {
        data() {
            return {
                // search data
                searchData: {
                    names: [],
                    date: &quot;&quot;,
                },
                columns: [
                    {
                        field: &quot;name&quot;,
                        key: &quot;a&quot;,
                        title: &quot;Name&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                        // filter
                        filter: {
                            filterList: NAME_FILTER_LIST,
                            isMultiple: true,
                            // filter confirm hook
                            filterConfirm: (filterList) =&gt; {
                                const labels = filterList
                                    .filter((x) =&gt; x.selected)
                                    .map((x) =&gt; x.label);
                                this.searchData.names = labels;
                            },
                            // filter reset hook
                            filterReset: (filterList) =&gt; {
                                this.searchData.names = [];
                            },
                        },
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Date&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                        // filter
                        filter: {
                            filterList: Date_FILTER_LIST,
                            // filter confirm hook
                            filterConfirm: (filterList) =&gt; {
                                const item = filterList.find((x) =&gt; x.selected);
                                this.searchData.date = item ? item.label : &quot;&quot;;
                            },
                            // filter reset hook
                            filterReset: (filterList) =&gt; {
                                this.searchData.date = &quot;&quot;;
                            },
                        },
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;center&quot;,
                        width: &quot;30%&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        align: &quot;left&quot;,
                        width: &quot;40%&quot;,
                    },
                ],
                // real table data
                tableData: [],
                // source data
                sourceData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                        rowKey: 0,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                        rowKey: 1,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                        rowKey: 2,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                        rowKey: 3,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                        rowKey: 4,
                    },
                ],
            };
        },
        watch: {
            searchData: {
                handler: function () {
                    this.search();
                },
                immediate: true,
                deep: true,
            },
        },
        methods: {
            // search
            search() {
                const { names, date } = this.searchData;
                this.tableData = this.sourceData.filter(
                    (x) =&gt;
                        (date === &quot;&quot; || date === x.date) &amp;&amp;
                        (names.length === 0 || names.includes(x.name)),
                );
            },
        },
        created() {
            // default search by names
            this.searchData.names = NAME_FILTER_LIST.filter((x) =&gt; x.selected).map((x) =&gt; x.label);
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"max-height":300,"fixed-header":true,"columns":_vm.columns,"table-data":_vm.tableData}})]],2)}
var staticRenderFns = []

  
    // name fiter list
    const NAME_FILTER_LIST = [
        { value: 0, label: "John", selected: true },
        { value: 1, label: "Dickerson", selected: true },
        { value: 2, label: "Larsen", selected: false },
        { value: 3, label: "Geneva", selected: true },
        { value: 4, label: "Jami", selected: false },
    ];

    // date fiter list
    const Date_FILTER_LIST = [
        { value: 0, label: "1900-05-20", selected: false },
        { value: 1, label: "1910-06-20", selected: false },
        { value: 2, label: "2000-07-20", selected: false },
        { value: 3, label: "2010-08-20", selected: false },
        { value: 4, label: "2020-09-20", selected: false },
    ];

    const democomponentExport = {
        data() {
            return {
                // search data
                searchData: {
                    names: [],
                    date: "",
                },
                columns: [
                    {
                        field: "name",
                        key: "a",
                        title: "Name",
                        align: "left",
                        width: "15%",
                        // filter
                        filter: {
                            filterList: NAME_FILTER_LIST,
                            isMultiple: true,
                            // filter confirm hook
                            filterConfirm: (filterList) => {
                                const labels = filterList
                                    .filter((x) => x.selected)
                                    .map((x) => x.label);
                                this.searchData.names = labels;
                            },
                            // filter reset hook
                            filterReset: (filterList) => {
                                this.searchData.names = [];
                            },
                        },
                    },
                    {
                        field: "date",
                        key: "b",
                        title: "Date",
                        align: "left",
                        width: "15%",
                        // filter
                        filter: {
                            filterList: Date_FILTER_LIST,
                            // filter confirm hook
                            filterConfirm: (filterList) => {
                                const item = filterList.find((x) => x.selected);
                                this.searchData.date = item ? item.label : "";
                            },
                            // filter reset hook
                            filterReset: (filterList) => {
                                this.searchData.date = "";
                            },
                        },
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        align: "center",
                        width: "30%",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        align: "left",
                        width: "40%",
                    },
                ],
                // real table data
                tableData: [],
                // source data
                sourceData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shanghai",
                        rowKey: 0,
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                        rowKey: 1,
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                        rowKey: 2,
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                        rowKey: 3,
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                        rowKey: 4,
                    },
                ],
            };
        },
        watch: {
            searchData: {
                handler: function () {
                    this.search();
                },
                immediate: true,
                deep: true,
            },
        },
        methods: {
            // search
            search() {
                const { names, date } = this.searchData;
                this.tableData = this.sourceData.filter(
                    (x) =>
                        (date === "" || date === x.date) &&
                        (names.length === 0 || names.includes(x.name)),
                );
            },
        },
        created() {
            // default search by names
            this.searchData.names = NAME_FILTER_LIST.filter((x) => x.selected).map((x) => x.label);
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  